import React from 'react';
import Dialog from '@mui/material/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export const Loading = ({ modal = false, color = 'primary', size = 40 }) => {
  const circularProgress = <CircularProgress color={color} size={size} />;

  return modal ? (
    <Dialog
      open
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflow: 'hidden'
        }
      }}
    >
      <div>{circularProgress}</div>
    </Dialog>
  ) : (
    <Box sx={{ textAlign: 'center' }}>{circularProgress}</Box>
  );
};
